import { render, staticRenderFns } from "./ChartBase.vue?vue&type=template&id=b1a2c2d6&scoped=true"
import script from "./ChartBase.vue?vue&type=script&lang=ts"
export * from "./ChartBase.vue?vue&type=script&lang=ts"
import style0 from "./ChartBase.vue?vue&type=style&index=0&id=b1a2c2d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a2c2d6",
  null
  
)

export default component.exports